<!-- Breadcrumb -->
<div class="pag-container">

  <app-campaign-3-breadcrumb
  data-testid="associationBreadcrumb"
  #breadcrumbComponent
  *ngIf="showBreadCrumb"
  [arrayBreadcrumbs]="breadcrumbs"
  (onClickBreadcrumb)="breadcrumbClicked($event)"
  homeLink="">
</app-campaign-3-breadcrumb>


  <!-- Bottoni gialli di lista azioni e creazione -->
  <div class="ui-g-12 d-flex justify-content-center">
      <div class="ui-g-7">
      </div>
      <div class="ui-g-5 footer-btn-container">
          <!-- Bottone con data-testid -->
          <button data-testid="insertNewAssociation" class="btn-page-act" (click)="onOpenCreation()">
              <i class="pi pi-plus"></i> <span>{{ 'cardAssociation.insert_new_association' | translate }}</span>
          </button>
      </div>
  </div>

  <div class="ui-g-12 prova">
      <app-campaign-3-kontable *ngIf="readyTable" #associations 
          [columns]="[
          { field: 'id', title: 'campaign.id', filterType: textFilter, bodyTemplate: idTemplate },
            { field: 'hostCodeFullName', title: 'cardAssociation.customer', filterType: textFilter, bodyTemplate: descriptionTemplate },
            { field: 'storeRequest', title: 'cardAssociation.storeReq', filterType: textFilter, bodyTemplate: descriptionTemplate },
            { field: 'uuid', title: 'cardAssociation.uuid', filterType: textFilter, bodyTemplate: clustersTemplate },
            { field: 'storeAssociation', title: 'cardAssociation.storeAssociation', filterType: textFilter, bodyTemplate: promoTemplate },
            { field: 'cardNo', title: 'cardAssociation.card', filterType: textFilter, bodyTemplate: promoTemplate },
            { field: 'returnCode', title: 'cardAssociation.status', filterType: selectFilter, filterOptions: { values: statusList }, bodyTemplate: statusTemplate },
            { field: 'dateStart', title: 'cardAssociation.associationDate', type: 'date', filterType: dateFilter, bodyTemplate: lastUpdateDateTemplate },
            { field: 'rcMessage', title: 'cardAssociation.message', filterType: textFilter, bodyTemplate: promoTemplate }
          ]"      
          [service]="associationService"  
          [paginationType]="paginationType"  
          [additionalRowCommands]="actions"  
          [expandTable]="false"  
          [fetchActionListAsap]="false"  
          [subjectToLoad]="pageSubject"  
          [filterBySingleColumn]="false"  
          [showRecoverButton]="false"  
          [showInfoButton]="false"  
          [showAddButton]="false"  
          [showDeleteButton]="false"  
          [showDetailsButton]="false"  
          [showEditButton]="false"  
          [fetchDistributionListDetailListAsap]="false"  
          [showGlobalFilter]="true">


          <ng-template #idTemplate let-row>
            <div class="center-content">
              <span>{{ row.id }}</span>
            </div>
            
          </ng-template>
          

          <ng-template #actions let-row>
              <div class="d-flex justify-content-center" *ngIf="row.returnCode=='N'">
                  <!-- Bottone dinamico con data-testid e data-testid-generic -->
                  <button
                      data-testid-generic="cardAssociations"
                      [attr.data-testid]="'cardAssociations' + row.id"
                      pTooltip="{{ 'cardAssociation.sendEmailAgain' | translate }}"
                      class="roundedButton"
                      (click)="reSendEmail(row)">
                      <i class="pi pi-envelope icon-size"></i>
                  </button>
              </div>
          </ng-template>

          <ng-template #statusTemplate let-row>
              <span>{{ getStatusDescription(row.returnCode) }}</span>
          </ng-template>
      </app-campaign-3-kontable>
  </div>
</div>

<footer></footer>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/card-association/card-association.component.html